/* eslint-disable */
import { Table, DatePicker, Select, Flex, Radio } from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import { SyncOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

const MaintenceMain = forwardRef(() => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableoading, setTableLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [reportList, setReportList] = useState([]);
  const originalReportList = useRef([]);
  const [currentReportList, setCurrentReportList] = useState(reportList);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const handlTotalRequestCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Request"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlInvoicedCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Invoiced"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlNoInvoicedClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "No Invoiced"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlTotalReviewCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Review"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlInvoicedReviewCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Invoiced Review"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlNoInvoicedReviewCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "No Invoiced Review"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const formatCount = (count) => {
  if (count === null || count === undefined) return "-";
  return Number(count) === 0 ? "-" : count;
};


const makeStatusRenderer = (statusName, onClick) => (_, record) => {
  const count = record?.statusList?.find(s => s.statusName === statusName)?.count;
  const value = formatCount(count);
  const clickable = value !== "-";
  return (
    <span
      style={{
        color: clickable ? "#0e78a9" : "inherit",
        // textDecoration: clickable ? "underline" : "none",
        cursor: clickable ? "pointer" : "default",
      }}
      onClick={() => clickable && onClick(record)}
    >
      {value}
    </span>
  );
};
  const initColumns = [
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      hidden: false,
      width: 300,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text) => text,
    },
    {
      title: "Total Request",
      dataIndex: "Total Request",
      key: "Total Request",
      hidden: false,
      width: 200,
      align: "center",
     render: makeStatusRenderer("Total Request", handlTotalRequestCountClick),
    },

    {
      title: "Invoiced",
      dataIndex: "Invoiced",
      key: "Invoiced",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
  render: makeStatusRenderer("Invoiced", handlInvoicedCountClick),
    },
    {
      title: "No Invoiced",
      dataIndex: "No Invoiced",
      key: "No Invoiced",
      hidden: false,
      width: 300,
      align: "center",
render: makeStatusRenderer("No Invoiced", handlNoInvoicedClick),
    },
    {
      title: "Total Review",
      dataIndex: "Total Review",
      key: "Total Review",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
   render: makeStatusRenderer("Total Review", handlTotalReviewCountClick),
    },
    {
      title: "Invoiced Review",
      dataIndex: "Invoiced Review",
      key: "Invoiced Review",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
  render: makeStatusRenderer("Invoiced Review", handlInvoicedReviewCountClick),
    },
    {
      title: "No Invoiced Review",
      dataIndex: "No Invoiced Review",
      key: "No Invoiced Review",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
    render: makeStatusRenderer("No Invoiced Review", handlNoInvoicedReviewCountClick),
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 获取所有的report
  const reportAllData = async (accountId) => {
    try {
      setTableLoading(true);
      const params = {
        accountId: accountId,
      };
      const response = await http.get(`${api.getMoWorkerInvoiceReport}`, {
        params,
      });
      const dataWithKey = (response.data || []).map((item) => ({
        ...item,
        key: item.vendorId,
      }));
      setFilteredData(dataWithKey);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  // select
  const onTypeChange = (value, option) => {
  setSelectedSupervisor(value); 
  if (!value) {
    setSelectedReport(null);
    return;
  }
  setSelectedReport(option?.label || "");
  reportAllData(value);
};

  const stepSearchChange = (value) => {
    if (!value) {
      setCurrentReportList(originalReportList.current);
      return;
    }
    const searchTerm = value.toLowerCase();
    const filtered = originalReportList.current.filter((item) =>
      item.label.toLowerCase().includes(searchTerm)
    );
    setCurrentReportList(filtered);
  };

  const getSupervisorList = async () => {
    try {
      const response = await http.get(api.getSupervisorList);
      console.log("response", response);
      if (response.code === "1") {
        const options = response.data.map((item) => ({
          value: item.accountId,
          label: item.fullName,
        }));
        setReportList(options);
        originalReportList.current = options;
        setCurrentReportList(options);
      }
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    }
  };

  // 初始化函数
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    reportAllData();
    setSelectedSupervisor(null);
  };
  useEffect(() => {
    // reportAllData()
    getSupervisorList();
  }, []);
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
          <Select
            showSearch
            allowClear
            placeholder="Select a supervisor"
            onChange={onTypeChange}
            onSearch={stepSearchChange}
            value={selectedSupervisor}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={currentReportList}
            style={{ width: 480, marginBottom: 30, marginTop: 20,textAlign: "left"}}
          />
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      <Table
        rowClassName="table-row-gradient"
        loading={tableoading}
        bordered={true}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={false}
        rowKey="accountId"
        scroll={{
          x: "max-content",
          y: "calc(100vh - 350px)",
        }}
        className="maintenance-report-Table"
      />
    </div>
  );
});
export default MaintenceMain;
